/* tslint:disable */
/* eslint-disable */
import { PaymentDisplayModel as AceXFoundPortalCoreCaqModelsPaymentDisplayModel } from '../../../../../../ace/xFound/Portal/Core/CAQ/Models/payment-display-model';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..
import { PaymentDisplayModelFormGroup as AceXFoundPortalCoreCaqModelsPaymentDisplayModelFormGroup } from '@/api/model-index';

export interface IMittelabrufDataDisplayModel {
  payments?: null | Array<AceXFoundPortalCoreCaqModelsPaymentDisplayModel>;
}
export class MittelabrufDataDisplayModel extends BaseModel implements IMittelabrufDataDisplayModel {
  payments?: null | Array<AceXFoundPortalCoreCaqModelsPaymentDisplayModel>;
}
class BaseMittelabrufDataDisplayModelFormGroup extends FormGroup {
  private static _instance: MittelabrufDataDisplayModelFormGroup;
  
  public static get Instance(): MittelabrufDataDisplayModelFormGroup {
    this._instance = new MittelabrufDataDisplayModelFormGroup({
      payments: new FormArray([]),
    });

    return this._instance;
  }
}


export class MittelabrufDataDisplayModelFormGroup extends BaseMittelabrufDataDisplayModelFormGroup {
  public get Payments(): FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsPaymentDisplayModelFormGroup> {
    return this.controls["payments"] as FormArray<FormControl<null> | AceXFoundPortalCoreCaqModelsPaymentDisplayModelFormGroup>;
  }
  

}

export module MittelabrufDataDisplayModelForm
  {
    export class FormFields
    {
      static _payments: string = "payments";
    }
  }

